import { en, id } from "@/languages";
import { createI18n } from "vue-i18n";

let language = "en";
const FALLBACK_LANGUAGE = "en";

if (typeof window !== "undefined") {
  language = localStorage?.getItem("website_language") != null ? localStorage?.getItem("website_language") : FALLBACK_LANGUAGE;
}

const instance = createI18n({
  legacy: false,
  locale: language,
  fallbackLocale: FALLBACK_LANGUAGE,
  messages: { en, id },
  warnHtmlMessage: false, // Don't show warning if HTML used as message
});

export default instance;

export const i18n = instance.global;
